import { useEffect, useMemo, useState } from "react";
import Button from "../../componentes/button/button";
import MainCard from "../../componentes/card/MainCard";
import FuncionarioService from "../../services/resource/funcionarioService";
import TabelaFuncionario from "./TabelaFuncionario";
import { Dialog } from "primereact/dialog";
import Input from "../../componentes/input/input";
import { formatLocalDateTime } from "../../utils/formatDate";
import FilialService from "../../services/resource/filialService";
import DropDown from "../../componentes/dropdown/dropdown";
import * as Yup from "yup";
import { Formik } from "formik";
import { toast } from "react-toastify";
import { useAuth } from "../../context/authContext";
import FortesFiscalService from "../../services/resource/fortesFiscalService";
import { TabPanel, TabView } from "primereact/tabview";
import { renderMultiSelect } from "../bp/BPRelatorio";
import ParametrosComissaoService from "../../services/resource/ParametrosComissaoService";
import { exportarFuncionariosExcel } from "./ExportaFuncionairo";

const initialValues = {
    "id": null,
    "nome": "",
    "codigo": "",
    "cargo": "",
    "cpf": "",
    "nomeMae": "",
    "celular": "",
    "email": "",
    "dataAdmissao": "",
    "dataDemissao": null,
    "dataNascimento": "",
    "filialId": null,
    "filialNome": "",
    "codigoTrixlog": null,
    "codigoControl": "",
    "ativo": null,
    "sincronizadoComFortes": null,
    "sincronizadoComTrixlog": null,
    "usuarioNome": "",
    "usuarioId": "",
    "usuarioNomeUsuario": "",
    "usuarioEmail": "",
}

const schema = Yup.object({
    nome: Yup.string().required("Nome obrigatório"),
    cargo: Yup.string().required("Cargo obrigatório"),

    cpf: Yup.string().when("codigo", {
        is: (codigo) => codigo && codigo !== "",
        then: (schema) => schema.required("CPF obrigatório quando o Código RH estiver preenchido"),
        otherwise: (schema) => schema.notRequired()
    }),

    filialId: Yup.string().required("Filial obrigatória"),
});

function FuncionarioMain() {
    const { user } = useAuth();

    const perfilComissoes = user.perfis.includes('COMISSOES');

    const funcionarioService = new FuncionarioService();
    const fortesService = new FortesFiscalService();
    const filialService = new FilialService();
    const parametrosService = new ParametrosComissaoService();

    const [funcionarios, setFuncionarios] = useState([]);
    const [cargosPermitidos, setCargosPermitidos] = useState([]);
    const [funcionarioSelecionado, setFuncionarioSelecionado] = useState(initialValues);
    const [modalEdit, setModalEdit] = useState(false);
    const [modalVisualizacao, setModalVisualizacao] = useState(false);
    const [filiais, setFiliais] = useState([]);
    const [loadingTrixlog, setLoadingTrixlog] = useState(false);


    const [selectedFilters, setSelectedFilters] = useState({
        nomes: [],
        cargos: [],
        filiais: [],
        status: [],
        codigos: []
    });

    useEffect(() => {

        const carregarDados = async () => {

            await Promise.all([
                buscarFiliais(),
                buscarCargosPermitidos()
            ]);

        };

        carregarDados();

    }, []);

    useEffect(() => {

        if (
            user.perfis.includes('COMISSOES')
            && cargosPermitidos.length === 0
        ) {
            return;
        }

        buscarFuncionarios();

    }, [cargosPermitidos]);

    const buscarCargosPermitidos = async () => {

        const perfilComissoes = user.perfis.includes('COMISSOES');

        if (!perfilComissoes) {
            return;
        }

        const res = await parametrosService.listarTodosCargos();

        setCargosPermitidos(res.data || []);
    }

    const buscarFuncionarios = async () => {

        const perfilComissoes = user.perfis.includes('COMISSOES');

        const filtrosRequest = {
            ...selectedFilters
        };

        // força filial do usuário
        if (perfilComissoes) {
            filtrosRequest.cargos = cargosPermitidos
            filtrosRequest.filiais = [user.filialId];
        }

        const res = await funcionarioService.listaFuncionarios(filtrosRequest);

        setFuncionarios(res.data);
    }

    const buscarFiliais = async () => {
        await filialService.listar().then(res => {
            setFiliais(res.data);
        })
    }

    const abrirModalVisualizacao = (item) => {
        setModalVisualizacao(true);
        setFuncionarioSelecionado(item);
    }

    const abrirModalEdit = (item) => {
        setModalEdit(true);
        setFuncionarioSelecionado(item);
    }

    const closeModals = () => {
        setFuncionarioSelecionado(initialValues);
        setModalEdit(false);
        setModalVisualizacao(false);
    }

    const handleChange = (key, value) => {
        setSelectedFilters(prev => ({
            ...prev,
            [key]: value
        }));
    };

    const salvarFuncionario = async (values) => {

        let response;

        if (values.id) {

            response = await funcionarioService.atualizar(values);

            const funcionarioAtualizado = response.data;

            setFuncionarios(prev =>
                prev.map(item =>
                    item.id === funcionarioAtualizado.id
                        ? funcionarioAtualizado
                        : item
                )
            );

        } else {

            response = await funcionarioService.salvar(values);

            const novoFuncionario = response.data;

            setFuncionarios(prev => [
                novoFuncionario,
                ...prev
            ]);
        }

        closeModals();
    };

    const sincronizadoComTrixlog = async () => {
        setLoadingTrixlog(true);

        await toast.promise(
            funcionarioService.sincronizarTrixlog(),
            {
                pending: "Sincronizando com o Trixlog...",
                success: "Funcionários sincronizados com sucesso!",
                error: "Erro ao sincronizar com o Trixlog"
            }
        )
            .then(() => {
                buscarFuncionarios();
            })
            .finally(() => setLoadingTrixlog(false));
    };

    const sincronizarComFortes = async () => {
        setLoadingTrixlog(true);

        await toast.promise(
            fortesService.sincronizarFuncionariosFortes(),
            {
                pending: "Sincronizando com o Fortes RH...",
                success: "Funcionários sincronizados com sucesso!",
                error: "Erro ao sincronizar com o Fortes RH"
            }
        )
            .then(() => {
                buscarFuncionarios();
            })
            .finally(() => setLoadingTrixlog(false));
    };

    const funcionariosFiltrados = useMemo(() => {

        let lista = [...funcionarios];

        if (selectedFilters.nomes?.length > 0) {
            lista = lista.filter(f =>
                selectedFilters.nomes.includes(f.nome)
            );
        }

        if (selectedFilters.cargos?.length > 0) {
            lista = lista.filter(f =>
                selectedFilters.cargos.includes(f.cargo)
            );
        }

        if (selectedFilters.filiais?.length > 0) {
            lista = lista.filter(f =>
                selectedFilters.filiais.includes(f.filialId)
            );
        }

        if (selectedFilters.status?.length > 0) {
            lista = lista.filter(f =>
                selectedFilters.status.includes(f.ativo)
            );
        }

        return lista;

    }, [funcionarios, selectedFilters]);

    const cargosOptions = useMemo(() => {

        const perfilComissoes = user.perfis.includes('COMISSOES');

        let cargos = funcionarios
            .map(f => f.cargo)
            .filter(Boolean);

        // usuário COMISSOES vê apenas cargos parametrizados
        if (perfilComissoes) {

            cargos = cargos.filter(cargo =>
                cargosPermitidos.includes(cargo)
            );
        }

        return [...new Set(cargos)]
            .sort()
            .map(cargo => ({
                label: cargo,
                value: cargo
            }));

    }, [funcionarios, cargosPermitidos, user]);

    const nomesOptions = useMemo(() => {
        return [...new Set(
            funcionarios
                .map(f => f.nome)
                .filter(Boolean)
        )]
            .sort()
            .map(nome => ({
                label: nome,
                value: nome
            }));
    }, [funcionarios]);

    const filtros = useMemo(() => ({
        nomes: nomesOptions,
        cargos: cargosOptions,
        filiais: filiais.map(item => ({
            label: item.nome,
            value: item.id
        })),
        status: [
            { label: 'Ativo', value: true },
            { label: 'Inativo', value: false },
        ]
    }), [
        nomesOptions,
        cargosOptions,
        filiais
    ]);


    const header = <div className="flex gap-1">
        <Button variant="white" label="Sincronizar com Fortes RH" iconLeft="fa fa-sync" onClick={() => sincronizarComFortes()} />
        <Button variant="white" label="Sincronizar com Trixlog" iconLeft="fa fa-sync" onClick={() => sincronizadoComTrixlog()} />
        <Button variant="white" label="Exportar Excel" iconLeft="fa fa-file-excel" onClick={() => exportarFuncionariosExcel(funcionariosFiltrados)} />
        <Button label="Cadastrar Novo Funcionário" iconLeft="fa fa-plus" onClick={() => setModalEdit(true)} />
    </div>

    return (
        <MainCard
            title="Funcionários (Motoristas / Auxiliares)"
            header={header}>

            <div className="grid grid-cols-1 md:grid-cols-4 gap-3 pt-3 px-3">
                {renderMultiSelect("Nome", "nomes", filtros.nomes, "fa-user", selectedFilters, handleChange, false)}
                {renderMultiSelect("Cargo", "cargos", filtros.cargos, "fa-briefcase", selectedFilters, handleChange, false)}
                {perfilComissoes === false &&
                    renderMultiSelect("Filial", "filiais", filtros.filiais, "fa-building", selectedFilters, handleChange, false)
                }
                {renderMultiSelect("Status", "status", filtros.status, "fa-circle", selectedFilters, handleChange, false)}
            </div>

            <div className="pt-3">
                <TabelaFuncionario
                    lista={funcionariosFiltrados}
                    visualizar={abrirModalVisualizacao}
                    editar={abrirModalEdit}
                />
            </div>
            <Dialog
                header={
                    <div>
                        <h2 className="font-display text-xl font-semibold text-foreground">
                            {funcionarioSelecionado?.id
                                ? "Editar Funcionário"
                                : "Cadastrar Funcionário"}
                        </h2>

                        <p className="text-sm text-muted-foreground mt-1">
                            Gerencie os dados do funcionário: {funcionarioSelecionado?.nome}
                        </p>
                    </div>
                }
                visible={modalEdit}
                className="w-[95%] h-100"
                onHide={closeModals}
                blockScroll
                contentClassName="p-0"
            >

                {funcionarioSelecionado && (

                    <Formik
                        enableReinitialize
                        initialValues={{
                            id: funcionarioSelecionado?.id || null,

                            nome: funcionarioSelecionado?.nome || "",
                            cargo: funcionarioSelecionado?.cargo || "",
                            cpf: funcionarioSelecionado?.cpf || "",
                            celular: funcionarioSelecionado?.celular || "",
                            email: funcionarioSelecionado?.email || "",
                            nomeMae: funcionarioSelecionado?.nomeMae || "",
                            codigoTrixlog: funcionarioSelecionado?.codigoTrixlog || "",
                            codigoControl: funcionarioSelecionado?.codigoControl || "",
                            codigoConcept: funcionarioSelecionado?.codigoConcept || "",
                            codigoSolides: funcionarioSelecionado?.codigoSolides || "",
                            codigoSolar: funcionarioSelecionado?.codigoSolar || "",
                            codigo: funcionarioSelecionado?.codigo || "",
                            filialId: funcionarioSelecionado?.filialId || user.filialId,
                            ativo: funcionarioSelecionado?.ativo ?? true,
                            sincronizadoComFortes:
                                funcionarioSelecionado?.sincronizadoComFortes ?? false,
                            sincronizadoComTrixlog: funcionarioSelecionado?.sincronizadoComTrixlog ?? false,
                            usuarioId: funcionarioSelecionado?.usuarioId || null,
                            usuarioNomeUsuario: funcionarioSelecionado?.usuarioNomeUsuario || "",
                            usuarioEmail: funcionarioSelecionado?.usuarioEmail || "",
                            usuarioSenha: "",
                            perfil:
                                funcionarioSelecionado?.perfis?.[0] || "MOTORISTA",
                        }}
                        validationSchema={schema}
                        onSubmit={salvarFuncionario}
                    >

                        {({
                            values,
                            errors,
                            touched,
                            setFieldValue,
                            setFieldTouched,
                            handleSubmit
                        }) => (
                            <form onSubmit={handleSubmit}>
                                <div className="pt-4 px-4">
                                    <TabView>

                                        {/* ================================================= */}
                                        {/* DADOS BÁSICOS */}
                                        {/* ================================================= */}

                                        <TabPanel
                                            header={
                                                <div className="flex items-center gap-2">
                                                    <i className="fa fa-user" />
                                                    <span>Dados Básicos</span>
                                                </div>
                                            }
                                        >

                                            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-5 pt-4">

                                                <DropDown
                                                    label="Filial"
                                                    required
                                                    value={values.filialId}
                                                    options={filiais}
                                                    disabled={user.perfis.includes('COMISSOES')}
                                                    optionLabel="nome"
                                                    optionValue="id"
                                                    onChange={e => setFieldValue("filialId", e.target.value)}
                                                    onBlur={() => setFieldTouched("filialId", true)}
                                                    error={errors.filialId}
                                                    touched={touched.filialId}
                                                />

                                                <Input
                                                    label="Nome"
                                                    required
                                                    value={values.nome}
                                                    disabled={values.sincronizadoComFortes}
                                                    onChange={e => setFieldValue("nome", e.target.value)}
                                                    onBlur={() => setFieldTouched("nome", true)}
                                                    error={errors.nome}
                                                    touched={touched.nome}
                                                />

                                                <DropDown
                                                    label="Cargo"
                                                    required
                                                    options={cargosOptions}
                                                    value={values.cargo}
                                                    onChange={e => {

                                                        setFieldValue("cargo", e.target.value);

                                                        if (e.target.value === "MOTORISTA") {

                                                            if (!values.nomeUsuario && values.cpf) {
                                                                setFieldValue("nomeUsuario", values.cpf);
                                                            }

                                                            setFieldValue("perfil", "MOTORISTA");
                                                        }
                                                    }}
                                                    onBlur={() => setFieldTouched("cargo", true)}
                                                    error={errors.cargo}
                                                    touched={touched.cargo}
                                                />

                                                <Input
                                                    label="CPF"
                                                    type="number"
                                                    value={values.cpf}
                                                    disabled={values.sincronizadoComFortes}
                                                    onChange={e => {

                                                        setFieldValue("cpf", e.target.value);

                                                        if (!values.nomeUsuario) {
                                                            setFieldValue("nomeUsuario", e.target.value);
                                                        }
                                                    }}
                                                    onBlur={() => setFieldTouched("cpf", true)}
                                                    error={errors.cpf}
                                                    touched={touched.cpf}
                                                />

                                                <Input
                                                    label="Celular"
                                                    value={values.celular}
                                                    disabled={values.sincronizadoComFortes}
                                                    onChange={e => setFieldValue("celular", e.target.value)}
                                                />

                                                <Input
                                                    label="Email"
                                                    value={values.email}
                                                    disabled={values.sincronizadoComFortes}
                                                    onChange={e => setFieldValue("email", e.target.value)}
                                                    onBlur={() => setFieldTouched("email", true)}
                                                    error={errors.email}
                                                    touched={touched.email}
                                                />

                                            </div>

                                        </TabPanel>

                                        <TabPanel
                                            header={
                                                <div className="flex items-center gap-2">
                                                    <i className="fa fa-link" />
                                                    <span>Integrações</span>
                                                </div>
                                            }
                                        >

                                            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-5 pt-4">

                                                <Input
                                                    label="Código RH (Fortes)"
                                                    value={values.codigo}
                                                    onChange={e => setFieldValue("codigo", e.target.value)}
                                                />

                                                <Input
                                                    label="Código Sólides"
                                                    value={values.codigoSolides}
                                                    onChange={e => setFieldValue("codigoSolides", e.target.value)}
                                                />

                                                <Input
                                                    label="Código Trixlog"
                                                    value={values.codigoTrixlog}
                                                    onChange={e => setFieldValue("codigoTrixlog", e.target.value)}
                                                />

                                                <Input
                                                    label="Código Control"
                                                    value={values.codigoControl}
                                                    onChange={e => setFieldValue("codigoControl", e.target.value)}
                                                />

                                                <Input
                                                    label="Código Concept"
                                                    value={values.codigoConcept}
                                                    onChange={e => setFieldValue("codigoConcept", e.target.value)}
                                                />

                                                <Input
                                                    label="Código Solar (Crachá)"
                                                    value={values.codigoSolar}
                                                    onChange={e => setFieldValue("codigoSolar", e.target.value)}
                                                />

                                            </div>

                                        </TabPanel>

                                        <TabPanel
                                            header={
                                                <div className="flex items-center gap-2">
                                                    <i className="fa fa-lock" />
                                                    <span>Acesso ao Sistema</span>
                                                </div>
                                            }
                                        >

                                            <form autoComplete="off" className="pt-4 space-y-6">

                                                <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-5">

                                                    <Input
                                                        label="Nome de Usuário"
                                                        value={values.usuarioNomeUsuario}
                                                        onChange={e => setFieldValue("usuarioNomeUsuario", e.target.value)}
                                                    />

                                                    <Input
                                                        label="Email "
                                                        autoComplete="off"
                                                        value={values.usuarioEmail}
                                                        onChange={e => setFieldValue("usuarioEmail", e.target.value)}
                                                    />

                                                    {funcionarioSelecionado?.usuarioId === null &&
                                                        <Input
                                                            type="password"
                                                            label="Senha Inicial"
                                                            autoComplete="off"
                                                            value={values.usuarioSenha}
                                                            onChange={e => setFieldValue("usuarioSenha", e.target.value)}
                                                        />
                                                    }

                                                    <DropDown
                                                        label="Perfil"
                                                        value={values.perfil}
                                                        options={[
                                                            {
                                                                label: "Motorista",
                                                                value: "MOTORISTA"
                                                            },
                                                            {
                                                                label: "Auxiliar de Entrega",
                                                                value: "AUXILIAR_ENTREGA"
                                                            }
                                                        ]}
                                                        onChange={e => setFieldValue("perfil", e.target.value)}
                                                    />

                                                </div>

                                            </form>

                                        </TabPanel>

                                    </TabView>
                                </div>

                                {/* ================================================= */}
                                {/* FOOTER */}
                                {/* ================================================= */}



                                <div className="absolute w-100 bottom-0 bg-card border-t border-border p-4 flex justify-end gap-3">

                                    <div className="flex items-end gap-6 flex-wrap">

                                        <Checkbox
                                            label="Ativo"
                                            checked={values.ativo}
                                            onChange={e => setFieldValue("ativo", e)}
                                        />

                                        <Checkbox
                                            label="Sincronizado Fortes"
                                            checked={values.sincronizadoComFortes}
                                            disabled
                                        />

                                        <Checkbox
                                            label="Sincronizado Trixlog"
                                            checked={values.sincronizadoComTrixlog}
                                            disabled
                                        />

                                    </div>

                                    <div className="flex justify-end gap-2">

                                        <Button
                                            type="button"
                                            variant="gray"
                                            iconLeft="fa fa-arrow-left"
                                            label="Voltar"
                                            onClick={closeModals}
                                        />

                                        <Button
                                            type="submit"
                                            iconLeft="fa fa-save"
                                            label={
                                                values.id
                                                    ? "Atualizar"
                                                    : "Cadastrar"
                                            }
                                        />

                                    </div>

                                </div>
                            </form>
                        )}

                    </Formik>

                )}

            </Dialog>

            <Dialog
                header={funcionarioSelecionado?.nome}
                className="w-[95%]"
                blockScroll
                visible={modalVisualizacao}
                onHide={closeModals}>
                {funcionarioSelecionado && (
                    <div className="space-y-6 pt-3">

                        {/* BLOCO PRINCIPAL */}
                        <div className="grid grid-cols-3 gap-4">
                            <Campo label="Nome" value={funcionarioSelecionado.nome} />
                            <Campo label="Código Fortes" value={funcionarioSelecionado.codigo} />
                            <Campo label="Código Solar" value={funcionarioSelecionado.codigo} />
                            <Campo label="Código Trixlog" value={funcionarioSelecionado.codigo} />

                            <Campo label="Cargo" value={funcionarioSelecionado.cargo} />
                            <Campo label="Filial" value={funcionarioSelecionado.filialNome} />

                            <Campo label="CPF" value={(user.perfis.includes("ADMIN") || (user.perfis.includes("COMISSAO") && (user.filialId === funcionarioSelecionado.filialId))) ? funcionarioSelecionado.cpf : "Você não tem permissão para visualizar este dado"} />
                            <Campo label="Celular" value={funcionarioSelecionado.celular} />

                            <Campo label="Email" value={funcionarioSelecionado.email} />

                            <Campo label="Nascimento" value={formatLocalDateTime(funcionarioSelecionado.dataNascimento)} />
                            <Campo label="Admissão" value={formatLocalDateTime(funcionarioSelecionado.dataAdmissao)} />

                            <Campo label="Demissão" value={formatLocalDateTime(funcionarioSelecionado.dataDemissao)} />
                            <Campo label="Código Trixlog" value={funcionarioSelecionado.codigoTrixlog} />

                        </div>

                        {/* STATUS */}
                        <div className="flex gap-4 pt-4 border-t">

                            <StatusBadge
                                ativo={funcionarioSelecionado.ativo}
                                label="Ativo"
                            />

                            <StatusBadge
                                ativo={funcionarioSelecionado.sincronizadoComFortes}
                                label="Fortes"
                            />

                            <StatusBadge
                                ativo={funcionarioSelecionado.sincronizadoComTrixlog}
                                label="Trixlog"
                            />

                        </div>

                    </div>
                )}
            </Dialog>

        </MainCard>
    )
}

export default FuncionarioMain;

function Campo({ label, value }) {
    return (
        <div>
            <div className="text-xs text-muted-foreground">{label}</div>
            <div className="font-medium text-foreground">{value || "-"}</div>
        </div>
    );
}

function StatusBadge({ ativo, label }) {
    return (
        <span className={`px-3 py-1 rounded-full text-sm font-medium
            ${ativo
                ? "bg-success/10 text-success"
                : "bg-muted text-muted-foreground"}`}>
            {label}
        </span>
    );
}

function Checkbox({ label, checked, onChange, disabled }) {
    return (
        <label className="flex items-center gap-2">
            <input
                type="checkbox"
                checked={!!checked}
                disabled={disabled}
                onChange={e => onChange(e.target.checked)}
            />
            <span className="text-foreground">{label}</span>
        </label>
    );
}